/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FlightBookingHandoffStatus } from "./FlightBookingHandoffStatus";
import {
  FlightBookingHandoffStatusFromJSON,
  FlightBookingHandoffStatusFromJSONTyped,
  FlightBookingHandoffStatusToJSON,
  FlightBookingHandoffStatusToJSONTyped,
} from "./FlightBookingHandoffStatus";
import type { FlightSelectedObservation } from "./FlightSelectedObservation";
import {
  FlightSelectedObservationFromJSON,
  FlightSelectedObservationFromJSONTyped,
  FlightSelectedObservationToJSON,
  FlightSelectedObservationToJSONTyped,
} from "./FlightSelectedObservation";
import type { FlightBookingHandoffCapabilities } from "./FlightBookingHandoffCapabilities";
import {
  FlightBookingHandoffCapabilitiesFromJSON,
  FlightBookingHandoffCapabilitiesFromJSONTyped,
  FlightBookingHandoffCapabilitiesToJSON,
  FlightBookingHandoffCapabilitiesToJSONTyped,
} from "./FlightBookingHandoffCapabilities";
import type { FlightBookingHandoffQuote } from "./FlightBookingHandoffQuote";
import {
  FlightBookingHandoffQuoteFromJSON,
  FlightBookingHandoffQuoteFromJSONTyped,
  FlightBookingHandoffQuoteToJSON,
  FlightBookingHandoffQuoteToJSONTyped,
} from "./FlightBookingHandoffQuote";

/**
 *
 * @export
 * @interface FlightBookingHandoffResponse
 */
export interface FlightBookingHandoffResponse {
  /**
   * Persisted supplier execution mode; test consumers require an affirmative acknowledgment.
   * @type {boolean}
   * @memberof FlightBookingHandoffResponse
   */
  test?: boolean;
  /**
   *
   * @type {number}
   * @memberof FlightBookingHandoffResponse
   */
  schemaVersion: FlightBookingHandoffResponseSchemaVersionEnum;
  /**
   *
   * @type {string}
   * @memberof FlightBookingHandoffResponse
   */
  handoffId: string;
  /**
   *
   * @type {FlightBookingHandoffStatus}
   * @memberof FlightBookingHandoffResponse
   */
  status: FlightBookingHandoffStatus;
  /**
   *
   * @type {Date}
   * @memberof FlightBookingHandoffResponse
   */
  expiresAt: Date;
  /**
   *
   * @type {Set<string>}
   * @memberof FlightBookingHandoffResponse
   */
  reasonCodes: Set<string>;
  /**
   *
   * @type {FlightBookingHandoffCapabilities}
   * @memberof FlightBookingHandoffResponse
   */
  capabilities: FlightBookingHandoffCapabilities;
  /**
   *
   * @type {string}
   * @memberof FlightBookingHandoffResponse
   */
  checkoutUrl?: string | null;
  /**
   *
   * @type {string}
   * @memberof FlightBookingHandoffResponse
   */
  externalBookingUrl?: string | null;
  /**
   *
   * @type {FlightBookingHandoffQuote}
   * @memberof FlightBookingHandoffResponse
   */
  quote?: FlightBookingHandoffQuote | null;
  /**
   *
   * @type {FlightSelectedObservation}
   * @memberof FlightBookingHandoffResponse
   */
  selectedObservation?: FlightSelectedObservation | null;
}

/**
 * @export
 */
export const FlightBookingHandoffResponseSchemaVersionEnum = {
  NUMBER_1: 1,
} as const;
export type FlightBookingHandoffResponseSchemaVersionEnum =
  (typeof FlightBookingHandoffResponseSchemaVersionEnum)[keyof typeof FlightBookingHandoffResponseSchemaVersionEnum];

/**
 * Check if a given object implements the FlightBookingHandoffResponse interface.
 */
export function instanceOfFlightBookingHandoffResponse(
  value: object
): value is FlightBookingHandoffResponse {
  if (!("schemaVersion" in value) || value["schemaVersion"] === undefined)
    return false;
  if (!("handoffId" in value) || value["handoffId"] === undefined) return false;
  if (!("status" in value) || value["status"] === undefined) return false;
  if (!("expiresAt" in value) || value["expiresAt"] === undefined) return false;
  if (!("reasonCodes" in value) || value["reasonCodes"] === undefined)
    return false;
  if (!("capabilities" in value) || value["capabilities"] === undefined)
    return false;
  return true;
}

export function FlightBookingHandoffResponseFromJSON(
  json: any
): FlightBookingHandoffResponse {
  return FlightBookingHandoffResponseFromJSONTyped(json, false);
}

export function FlightBookingHandoffResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightBookingHandoffResponse {
  if (json == null) {
    return json;
  }
  return {
    test: json["test"] == null ? undefined : json["test"],
    schemaVersion: json["schema_version"],
    handoffId: json["handoff_id"],
    status: FlightBookingHandoffStatusFromJSON(json["status"]),
    expiresAt: new Date(json["expires_at"]),
    reasonCodes: new Set(json["reason_codes"]),
    capabilities: FlightBookingHandoffCapabilitiesFromJSON(
      json["capabilities"]
    ),
    checkoutUrl:
      json["checkout_url"] == null ? undefined : json["checkout_url"],
    externalBookingUrl:
      json["external_booking_url"] == null
        ? undefined
        : json["external_booking_url"],
    quote:
      json["quote"] == null
        ? undefined
        : FlightBookingHandoffQuoteFromJSON(json["quote"]),
    selectedObservation:
      json["selected_observation"] == null
        ? undefined
        : FlightSelectedObservationFromJSON(json["selected_observation"]),
  };
}

export function FlightBookingHandoffResponseToJSON(
  json: any
): FlightBookingHandoffResponse {
  return FlightBookingHandoffResponseToJSONTyped(json, false);
}

export function FlightBookingHandoffResponseToJSONTyped(
  value?: FlightBookingHandoffResponse | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    test: value["test"],
    schema_version: value["schemaVersion"],
    handoff_id: value["handoffId"],
    status: FlightBookingHandoffStatusToJSON(value["status"]),
    expires_at: value["expiresAt"].toISOString(),
    reason_codes: Array.from(value["reasonCodes"] as Set<any>),
    capabilities: FlightBookingHandoffCapabilitiesToJSON(value["capabilities"]),
    checkout_url: value["checkoutUrl"],
    external_booking_url: value["externalBookingUrl"],
    quote: FlightBookingHandoffQuoteToJSON(value["quote"]),
    selected_observation: FlightSelectedObservationToJSON(
      value["selectedObservation"]
    ),
  };
}
